export default "__VITE_ASSET__DgMPrF8y__"